import { Component } from 'react';
import {connect} from 'react-redux';
import {actions} from 'forms/rrf';
import {Col, Container, Row} from 'react-bootstrap';
import EditLevelForm from './edit-level-form';
import BackLink from '../../common/back-link/index';
import PageTitle from '../../common/page-title/index';
import {getLevel} from '../../../actions/levels';
import {initialStates} from '../../../initialStates';

class EditLevel extends Component {
  UNSAFE_componentWillMount() {
    const {dispatch, match} = this.props;
    this.id = +match.params.id;
    if (this.id) {
      dispatch(getLevel(this.id));
    }
  }

  componentWillUnmount() {
    const {dispatch} = this.props;

    dispatch(actions.load('deep.admin_level', initialStates.admin_level));
    dispatch({type: 'CLEAR_EDIT_LEVEL'});
  }

  render() {
    const {level} = this.props;
    const edit = !!this.id;

    return (
      <Container fluid className="levels">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/levels"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>
              {edit ? 'Edit' : 'Add'}
              {' '}
              level
            </PageTitle>
          </Col>
        </Row>
        <EditLevelForm
          edit={edit}
          level={level}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  ...state,
  level: state.level.level,
  fetched: state.level.fetched,
  fetching: state.level.fetching,
});

export default connect(mapStateToProps)(EditLevel);
